import { check } from './check'
import { login } from './login'

export const authApi = {
  check,
  login,
}
